import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbComponent } from "../shared/components/breadcrumb/breadcrumb.component";
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'cookie-privacy-policy',
    imports: [BreadcrumbComponent, TranslocoDirective],
    templateUrl: './cookie-privacy-policy.component.html'
})
export class CookiePrivacyPolicyComponent implements OnInit {
    private readonly router = inject(Router);
    
    ngOnInit(): void {

    }

    goToCookiePolicy() {
        this.router.navigate(['/cookiepolicy'])
    };

    goToPrivacyPolicy() {
        this.router.navigate(['/privacypolicy'])
    };
    
}
